/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var spine_options_pb = require('../../../../spine/options_pb.js');
var google_protobuf_any_pb = require('google-protobuf/google/protobuf/any_pb.js');
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
var spine_core_event_pb = require('../../../../spine/core/event_pb.js');
var spine_core_command_pb = require('../../../../spine/core/command_pb.js');
var spine_system_server_entity_history_pb = require('../../../../spine/system/server/entity_history_pb.js');
goog.exportSymbol('proto.spine.system.server.CommandDispatchedToHandler', null, global);
goog.exportSymbol('proto.spine.system.server.EntityArchived', null, global);
goog.exportSymbol('proto.spine.system.server.EntityCreated', null, global);
goog.exportSymbol('proto.spine.system.server.EntityDeleted', null, global);
goog.exportSymbol('proto.spine.system.server.EntityExtractedFromArchive', null, global);
goog.exportSymbol('proto.spine.system.server.EntityRestored', null, global);
goog.exportSymbol('proto.spine.system.server.EntityStateChanged', null, global);
goog.exportSymbol('proto.spine.system.server.EventDispatchedToReactor', null, global);
goog.exportSymbol('proto.spine.system.server.EventDispatchedToSubscriber', null, global);
goog.exportSymbol('proto.spine.system.server.EventImported', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.system.server.EntityCreated = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.system.server.EntityCreated, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.system.server.EntityCreated.displayName = 'proto.spine.system.server.EntityCreated';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.system.server.EntityCreated.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.system.server.EntityCreated.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.system.server.EntityCreated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.EntityCreated.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && spine_system_server_entity_history_pb.EntityHistoryId.toObject(includeInstance, f),
    kind: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.system.server.EntityCreated}
 */
proto.spine.system.server.EntityCreated.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.system.server.EntityCreated;
  return proto.spine.system.server.EntityCreated.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.system.server.EntityCreated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.system.server.EntityCreated}
 */
proto.spine.system.server.EntityCreated.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new spine_system_server_entity_history_pb.EntityHistoryId;
      reader.readMessage(value,spine_system_server_entity_history_pb.EntityHistoryId.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.EntityOption.Kind} */ (reader.readEnum());
      msg.setKind(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.system.server.EntityCreated.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.system.server.EntityCreated.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.system.server.EntityCreated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.EntityCreated.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      spine_system_server_entity_history_pb.EntityHistoryId.serializeBinaryToWriter
    );
  }
  f = message.getKind();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional EntityHistoryId id = 1;
 * @return {?proto.spine.system.server.EntityHistoryId}
 */
proto.spine.system.server.EntityCreated.prototype.getId = function() {
  return /** @type{?proto.spine.system.server.EntityHistoryId} */ (
    jspb.Message.getWrapperField(this, spine_system_server_entity_history_pb.EntityHistoryId, 1));
};


/** @param {?proto.spine.system.server.EntityHistoryId|undefined} value */
proto.spine.system.server.EntityCreated.prototype.setId = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.system.server.EntityCreated.prototype.clearId = function() {
  this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.EntityCreated.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional EntityOption.Kind kind = 2;
 * @return {!proto.EntityOption.Kind}
 */
proto.spine.system.server.EntityCreated.prototype.getKind = function() {
  return /** @type {!proto.EntityOption.Kind} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {!proto.EntityOption.Kind} value */
proto.spine.system.server.EntityCreated.prototype.setKind = function(value) {
  jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.system.server.EventDispatchedToSubscriber = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.system.server.EventDispatchedToSubscriber, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.system.server.EventDispatchedToSubscriber.displayName = 'proto.spine.system.server.EventDispatchedToSubscriber';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.system.server.EventDispatchedToSubscriber.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.system.server.EventDispatchedToSubscriber.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.system.server.EventDispatchedToSubscriber} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.EventDispatchedToSubscriber.toObject = function(includeInstance, msg) {
  var f, obj = {
    receiver: (f = msg.getReceiver()) && spine_system_server_entity_history_pb.EntityHistoryId.toObject(includeInstance, f),
    payload: (f = msg.getPayload()) && spine_core_event_pb.Event.toObject(includeInstance, f),
    whenDispatched: (f = msg.getWhenDispatched()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.system.server.EventDispatchedToSubscriber}
 */
proto.spine.system.server.EventDispatchedToSubscriber.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.system.server.EventDispatchedToSubscriber;
  return proto.spine.system.server.EventDispatchedToSubscriber.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.system.server.EventDispatchedToSubscriber} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.system.server.EventDispatchedToSubscriber}
 */
proto.spine.system.server.EventDispatchedToSubscriber.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new spine_system_server_entity_history_pb.EntityHistoryId;
      reader.readMessage(value,spine_system_server_entity_history_pb.EntityHistoryId.deserializeBinaryFromReader);
      msg.setReceiver(value);
      break;
    case 2:
      var value = new spine_core_event_pb.Event;
      reader.readMessage(value,spine_core_event_pb.Event.deserializeBinaryFromReader);
      msg.setPayload(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setWhenDispatched(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.system.server.EventDispatchedToSubscriber.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.system.server.EventDispatchedToSubscriber.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.system.server.EventDispatchedToSubscriber} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.EventDispatchedToSubscriber.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReceiver();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      spine_system_server_entity_history_pb.EntityHistoryId.serializeBinaryToWriter
    );
  }
  f = message.getPayload();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      spine_core_event_pb.Event.serializeBinaryToWriter
    );
  }
  f = message.getWhenDispatched();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional EntityHistoryId receiver = 1;
 * @return {?proto.spine.system.server.EntityHistoryId}
 */
proto.spine.system.server.EventDispatchedToSubscriber.prototype.getReceiver = function() {
  return /** @type{?proto.spine.system.server.EntityHistoryId} */ (
    jspb.Message.getWrapperField(this, spine_system_server_entity_history_pb.EntityHistoryId, 1));
};


/** @param {?proto.spine.system.server.EntityHistoryId|undefined} value */
proto.spine.system.server.EventDispatchedToSubscriber.prototype.setReceiver = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.system.server.EventDispatchedToSubscriber.prototype.clearReceiver = function() {
  this.setReceiver(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.EventDispatchedToSubscriber.prototype.hasReceiver = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional spine.core.Event payload = 2;
 * @return {?proto.spine.core.Event}
 */
proto.spine.system.server.EventDispatchedToSubscriber.prototype.getPayload = function() {
  return /** @type{?proto.spine.core.Event} */ (
    jspb.Message.getWrapperField(this, spine_core_event_pb.Event, 2));
};


/** @param {?proto.spine.core.Event|undefined} value */
proto.spine.system.server.EventDispatchedToSubscriber.prototype.setPayload = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.spine.system.server.EventDispatchedToSubscriber.prototype.clearPayload = function() {
  this.setPayload(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.EventDispatchedToSubscriber.prototype.hasPayload = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp when_dispatched = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.spine.system.server.EventDispatchedToSubscriber.prototype.getWhenDispatched = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/** @param {?proto.google.protobuf.Timestamp|undefined} value */
proto.spine.system.server.EventDispatchedToSubscriber.prototype.setWhenDispatched = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.spine.system.server.EventDispatchedToSubscriber.prototype.clearWhenDispatched = function() {
  this.setWhenDispatched(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.EventDispatchedToSubscriber.prototype.hasWhenDispatched = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.system.server.EventDispatchedToReactor = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.system.server.EventDispatchedToReactor, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.system.server.EventDispatchedToReactor.displayName = 'proto.spine.system.server.EventDispatchedToReactor';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.system.server.EventDispatchedToReactor.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.system.server.EventDispatchedToReactor.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.system.server.EventDispatchedToReactor} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.EventDispatchedToReactor.toObject = function(includeInstance, msg) {
  var f, obj = {
    receiver: (f = msg.getReceiver()) && spine_system_server_entity_history_pb.EntityHistoryId.toObject(includeInstance, f),
    payload: (f = msg.getPayload()) && spine_core_event_pb.Event.toObject(includeInstance, f),
    whenDispatched: (f = msg.getWhenDispatched()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.system.server.EventDispatchedToReactor}
 */
proto.spine.system.server.EventDispatchedToReactor.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.system.server.EventDispatchedToReactor;
  return proto.spine.system.server.EventDispatchedToReactor.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.system.server.EventDispatchedToReactor} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.system.server.EventDispatchedToReactor}
 */
proto.spine.system.server.EventDispatchedToReactor.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new spine_system_server_entity_history_pb.EntityHistoryId;
      reader.readMessage(value,spine_system_server_entity_history_pb.EntityHistoryId.deserializeBinaryFromReader);
      msg.setReceiver(value);
      break;
    case 2:
      var value = new spine_core_event_pb.Event;
      reader.readMessage(value,spine_core_event_pb.Event.deserializeBinaryFromReader);
      msg.setPayload(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setWhenDispatched(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.system.server.EventDispatchedToReactor.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.system.server.EventDispatchedToReactor.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.system.server.EventDispatchedToReactor} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.EventDispatchedToReactor.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReceiver();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      spine_system_server_entity_history_pb.EntityHistoryId.serializeBinaryToWriter
    );
  }
  f = message.getPayload();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      spine_core_event_pb.Event.serializeBinaryToWriter
    );
  }
  f = message.getWhenDispatched();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional EntityHistoryId receiver = 1;
 * @return {?proto.spine.system.server.EntityHistoryId}
 */
proto.spine.system.server.EventDispatchedToReactor.prototype.getReceiver = function() {
  return /** @type{?proto.spine.system.server.EntityHistoryId} */ (
    jspb.Message.getWrapperField(this, spine_system_server_entity_history_pb.EntityHistoryId, 1));
};


/** @param {?proto.spine.system.server.EntityHistoryId|undefined} value */
proto.spine.system.server.EventDispatchedToReactor.prototype.setReceiver = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.system.server.EventDispatchedToReactor.prototype.clearReceiver = function() {
  this.setReceiver(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.EventDispatchedToReactor.prototype.hasReceiver = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional spine.core.Event payload = 2;
 * @return {?proto.spine.core.Event}
 */
proto.spine.system.server.EventDispatchedToReactor.prototype.getPayload = function() {
  return /** @type{?proto.spine.core.Event} */ (
    jspb.Message.getWrapperField(this, spine_core_event_pb.Event, 2));
};


/** @param {?proto.spine.core.Event|undefined} value */
proto.spine.system.server.EventDispatchedToReactor.prototype.setPayload = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.spine.system.server.EventDispatchedToReactor.prototype.clearPayload = function() {
  this.setPayload(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.EventDispatchedToReactor.prototype.hasPayload = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp when_dispatched = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.spine.system.server.EventDispatchedToReactor.prototype.getWhenDispatched = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/** @param {?proto.google.protobuf.Timestamp|undefined} value */
proto.spine.system.server.EventDispatchedToReactor.prototype.setWhenDispatched = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.spine.system.server.EventDispatchedToReactor.prototype.clearWhenDispatched = function() {
  this.setWhenDispatched(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.EventDispatchedToReactor.prototype.hasWhenDispatched = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.system.server.CommandDispatchedToHandler = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.system.server.CommandDispatchedToHandler, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.system.server.CommandDispatchedToHandler.displayName = 'proto.spine.system.server.CommandDispatchedToHandler';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.system.server.CommandDispatchedToHandler.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.system.server.CommandDispatchedToHandler.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.system.server.CommandDispatchedToHandler} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.CommandDispatchedToHandler.toObject = function(includeInstance, msg) {
  var f, obj = {
    receiver: (f = msg.getReceiver()) && spine_system_server_entity_history_pb.EntityHistoryId.toObject(includeInstance, f),
    payload: (f = msg.getPayload()) && spine_core_command_pb.Command.toObject(includeInstance, f),
    whenDispatched: (f = msg.getWhenDispatched()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.system.server.CommandDispatchedToHandler}
 */
proto.spine.system.server.CommandDispatchedToHandler.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.system.server.CommandDispatchedToHandler;
  return proto.spine.system.server.CommandDispatchedToHandler.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.system.server.CommandDispatchedToHandler} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.system.server.CommandDispatchedToHandler}
 */
proto.spine.system.server.CommandDispatchedToHandler.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new spine_system_server_entity_history_pb.EntityHistoryId;
      reader.readMessage(value,spine_system_server_entity_history_pb.EntityHistoryId.deserializeBinaryFromReader);
      msg.setReceiver(value);
      break;
    case 2:
      var value = new spine_core_command_pb.Command;
      reader.readMessage(value,spine_core_command_pb.Command.deserializeBinaryFromReader);
      msg.setPayload(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setWhenDispatched(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.system.server.CommandDispatchedToHandler.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.system.server.CommandDispatchedToHandler.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.system.server.CommandDispatchedToHandler} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.CommandDispatchedToHandler.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReceiver();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      spine_system_server_entity_history_pb.EntityHistoryId.serializeBinaryToWriter
    );
  }
  f = message.getPayload();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      spine_core_command_pb.Command.serializeBinaryToWriter
    );
  }
  f = message.getWhenDispatched();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional EntityHistoryId receiver = 1;
 * @return {?proto.spine.system.server.EntityHistoryId}
 */
proto.spine.system.server.CommandDispatchedToHandler.prototype.getReceiver = function() {
  return /** @type{?proto.spine.system.server.EntityHistoryId} */ (
    jspb.Message.getWrapperField(this, spine_system_server_entity_history_pb.EntityHistoryId, 1));
};


/** @param {?proto.spine.system.server.EntityHistoryId|undefined} value */
proto.spine.system.server.CommandDispatchedToHandler.prototype.setReceiver = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.system.server.CommandDispatchedToHandler.prototype.clearReceiver = function() {
  this.setReceiver(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.CommandDispatchedToHandler.prototype.hasReceiver = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional spine.core.Command payload = 2;
 * @return {?proto.spine.core.Command}
 */
proto.spine.system.server.CommandDispatchedToHandler.prototype.getPayload = function() {
  return /** @type{?proto.spine.core.Command} */ (
    jspb.Message.getWrapperField(this, spine_core_command_pb.Command, 2));
};


/** @param {?proto.spine.core.Command|undefined} value */
proto.spine.system.server.CommandDispatchedToHandler.prototype.setPayload = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.spine.system.server.CommandDispatchedToHandler.prototype.clearPayload = function() {
  this.setPayload(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.CommandDispatchedToHandler.prototype.hasPayload = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp when_dispatched = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.spine.system.server.CommandDispatchedToHandler.prototype.getWhenDispatched = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/** @param {?proto.google.protobuf.Timestamp|undefined} value */
proto.spine.system.server.CommandDispatchedToHandler.prototype.setWhenDispatched = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.spine.system.server.CommandDispatchedToHandler.prototype.clearWhenDispatched = function() {
  this.setWhenDispatched(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.CommandDispatchedToHandler.prototype.hasWhenDispatched = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.system.server.EventImported = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.system.server.EventImported, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.system.server.EventImported.displayName = 'proto.spine.system.server.EventImported';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.system.server.EventImported.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.system.server.EventImported.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.system.server.EventImported} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.EventImported.toObject = function(includeInstance, msg) {
  var f, obj = {
    receiver: (f = msg.getReceiver()) && spine_system_server_entity_history_pb.EntityHistoryId.toObject(includeInstance, f),
    eventId: (f = msg.getEventId()) && spine_core_event_pb.EventId.toObject(includeInstance, f),
    whenImported: (f = msg.getWhenImported()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.system.server.EventImported}
 */
proto.spine.system.server.EventImported.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.system.server.EventImported;
  return proto.spine.system.server.EventImported.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.system.server.EventImported} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.system.server.EventImported}
 */
proto.spine.system.server.EventImported.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new spine_system_server_entity_history_pb.EntityHistoryId;
      reader.readMessage(value,spine_system_server_entity_history_pb.EntityHistoryId.deserializeBinaryFromReader);
      msg.setReceiver(value);
      break;
    case 2:
      var value = new spine_core_event_pb.EventId;
      reader.readMessage(value,spine_core_event_pb.EventId.deserializeBinaryFromReader);
      msg.setEventId(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setWhenImported(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.system.server.EventImported.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.system.server.EventImported.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.system.server.EventImported} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.EventImported.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReceiver();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      spine_system_server_entity_history_pb.EntityHistoryId.serializeBinaryToWriter
    );
  }
  f = message.getEventId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      spine_core_event_pb.EventId.serializeBinaryToWriter
    );
  }
  f = message.getWhenImported();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional EntityHistoryId receiver = 1;
 * @return {?proto.spine.system.server.EntityHistoryId}
 */
proto.spine.system.server.EventImported.prototype.getReceiver = function() {
  return /** @type{?proto.spine.system.server.EntityHistoryId} */ (
    jspb.Message.getWrapperField(this, spine_system_server_entity_history_pb.EntityHistoryId, 1));
};


/** @param {?proto.spine.system.server.EntityHistoryId|undefined} value */
proto.spine.system.server.EventImported.prototype.setReceiver = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.system.server.EventImported.prototype.clearReceiver = function() {
  this.setReceiver(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.EventImported.prototype.hasReceiver = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional spine.core.EventId event_id = 2;
 * @return {?proto.spine.core.EventId}
 */
proto.spine.system.server.EventImported.prototype.getEventId = function() {
  return /** @type{?proto.spine.core.EventId} */ (
    jspb.Message.getWrapperField(this, spine_core_event_pb.EventId, 2));
};


/** @param {?proto.spine.core.EventId|undefined} value */
proto.spine.system.server.EventImported.prototype.setEventId = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.spine.system.server.EventImported.prototype.clearEventId = function() {
  this.setEventId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.EventImported.prototype.hasEventId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp when_imported = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.spine.system.server.EventImported.prototype.getWhenImported = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/** @param {?proto.google.protobuf.Timestamp|undefined} value */
proto.spine.system.server.EventImported.prototype.setWhenImported = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.spine.system.server.EventImported.prototype.clearWhenImported = function() {
  this.setWhenImported(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.EventImported.prototype.hasWhenImported = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.system.server.EntityStateChanged = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.spine.system.server.EntityStateChanged.repeatedFields_, null);
};
goog.inherits(proto.spine.system.server.EntityStateChanged, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.system.server.EntityStateChanged.displayName = 'proto.spine.system.server.EntityStateChanged';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.spine.system.server.EntityStateChanged.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.system.server.EntityStateChanged.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.system.server.EntityStateChanged.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.system.server.EntityStateChanged} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.EntityStateChanged.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && spine_system_server_entity_history_pb.EntityHistoryId.toObject(includeInstance, f),
    newState: (f = msg.getNewState()) && google_protobuf_any_pb.Any.toObject(includeInstance, f),
    messageIdList: jspb.Message.toObjectList(msg.getMessageIdList(),
    spine_system_server_entity_history_pb.DispatchedMessageId.toObject, includeInstance),
    when: (f = msg.getWhen()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.system.server.EntityStateChanged}
 */
proto.spine.system.server.EntityStateChanged.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.system.server.EntityStateChanged;
  return proto.spine.system.server.EntityStateChanged.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.system.server.EntityStateChanged} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.system.server.EntityStateChanged}
 */
proto.spine.system.server.EntityStateChanged.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new spine_system_server_entity_history_pb.EntityHistoryId;
      reader.readMessage(value,spine_system_server_entity_history_pb.EntityHistoryId.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_any_pb.Any;
      reader.readMessage(value,google_protobuf_any_pb.Any.deserializeBinaryFromReader);
      msg.setNewState(value);
      break;
    case 3:
      var value = new spine_system_server_entity_history_pb.DispatchedMessageId;
      reader.readMessage(value,spine_system_server_entity_history_pb.DispatchedMessageId.deserializeBinaryFromReader);
      msg.addMessageId(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setWhen(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.system.server.EntityStateChanged.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.system.server.EntityStateChanged.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.system.server.EntityStateChanged} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.EntityStateChanged.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      spine_system_server_entity_history_pb.EntityHistoryId.serializeBinaryToWriter
    );
  }
  f = message.getNewState();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_any_pb.Any.serializeBinaryToWriter
    );
  }
  f = message.getMessageIdList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      spine_system_server_entity_history_pb.DispatchedMessageId.serializeBinaryToWriter
    );
  }
  f = message.getWhen();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional EntityHistoryId id = 1;
 * @return {?proto.spine.system.server.EntityHistoryId}
 */
proto.spine.system.server.EntityStateChanged.prototype.getId = function() {
  return /** @type{?proto.spine.system.server.EntityHistoryId} */ (
    jspb.Message.getWrapperField(this, spine_system_server_entity_history_pb.EntityHistoryId, 1));
};


/** @param {?proto.spine.system.server.EntityHistoryId|undefined} value */
proto.spine.system.server.EntityStateChanged.prototype.setId = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.system.server.EntityStateChanged.prototype.clearId = function() {
  this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.EntityStateChanged.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Any new_state = 2;
 * @return {?proto.google.protobuf.Any}
 */
proto.spine.system.server.EntityStateChanged.prototype.getNewState = function() {
  return /** @type{?proto.google.protobuf.Any} */ (
    jspb.Message.getWrapperField(this, google_protobuf_any_pb.Any, 2));
};


/** @param {?proto.google.protobuf.Any|undefined} value */
proto.spine.system.server.EntityStateChanged.prototype.setNewState = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.spine.system.server.EntityStateChanged.prototype.clearNewState = function() {
  this.setNewState(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.EntityStateChanged.prototype.hasNewState = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated DispatchedMessageId message_id = 3;
 * @return {!Array<!proto.spine.system.server.DispatchedMessageId>}
 */
proto.spine.system.server.EntityStateChanged.prototype.getMessageIdList = function() {
  return /** @type{!Array<!proto.spine.system.server.DispatchedMessageId>} */ (
    jspb.Message.getRepeatedWrapperField(this, spine_system_server_entity_history_pb.DispatchedMessageId, 3));
};


/** @param {!Array<!proto.spine.system.server.DispatchedMessageId>} value */
proto.spine.system.server.EntityStateChanged.prototype.setMessageIdList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.spine.system.server.DispatchedMessageId=} opt_value
 * @param {number=} opt_index
 * @return {!proto.spine.system.server.DispatchedMessageId}
 */
proto.spine.system.server.EntityStateChanged.prototype.addMessageId = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.spine.system.server.DispatchedMessageId, opt_index);
};


proto.spine.system.server.EntityStateChanged.prototype.clearMessageIdList = function() {
  this.setMessageIdList([]);
};


/**
 * optional google.protobuf.Timestamp when = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.spine.system.server.EntityStateChanged.prototype.getWhen = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/** @param {?proto.google.protobuf.Timestamp|undefined} value */
proto.spine.system.server.EntityStateChanged.prototype.setWhen = function(value) {
  jspb.Message.setWrapperField(this, 4, value);
};


proto.spine.system.server.EntityStateChanged.prototype.clearWhen = function() {
  this.setWhen(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.EntityStateChanged.prototype.hasWhen = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.system.server.EntityArchived = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.spine.system.server.EntityArchived.repeatedFields_, null);
};
goog.inherits(proto.spine.system.server.EntityArchived, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.system.server.EntityArchived.displayName = 'proto.spine.system.server.EntityArchived';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.spine.system.server.EntityArchived.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.system.server.EntityArchived.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.system.server.EntityArchived.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.system.server.EntityArchived} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.EntityArchived.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && spine_system_server_entity_history_pb.EntityHistoryId.toObject(includeInstance, f),
    messageIdList: jspb.Message.toObjectList(msg.getMessageIdList(),
    spine_system_server_entity_history_pb.DispatchedMessageId.toObject, includeInstance),
    when: (f = msg.getWhen()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.system.server.EntityArchived}
 */
proto.spine.system.server.EntityArchived.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.system.server.EntityArchived;
  return proto.spine.system.server.EntityArchived.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.system.server.EntityArchived} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.system.server.EntityArchived}
 */
proto.spine.system.server.EntityArchived.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new spine_system_server_entity_history_pb.EntityHistoryId;
      reader.readMessage(value,spine_system_server_entity_history_pb.EntityHistoryId.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 2:
      var value = new spine_system_server_entity_history_pb.DispatchedMessageId;
      reader.readMessage(value,spine_system_server_entity_history_pb.DispatchedMessageId.deserializeBinaryFromReader);
      msg.addMessageId(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setWhen(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.system.server.EntityArchived.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.system.server.EntityArchived.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.system.server.EntityArchived} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.EntityArchived.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      spine_system_server_entity_history_pb.EntityHistoryId.serializeBinaryToWriter
    );
  }
  f = message.getMessageIdList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      spine_system_server_entity_history_pb.DispatchedMessageId.serializeBinaryToWriter
    );
  }
  f = message.getWhen();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional EntityHistoryId id = 1;
 * @return {?proto.spine.system.server.EntityHistoryId}
 */
proto.spine.system.server.EntityArchived.prototype.getId = function() {
  return /** @type{?proto.spine.system.server.EntityHistoryId} */ (
    jspb.Message.getWrapperField(this, spine_system_server_entity_history_pb.EntityHistoryId, 1));
};


/** @param {?proto.spine.system.server.EntityHistoryId|undefined} value */
proto.spine.system.server.EntityArchived.prototype.setId = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.system.server.EntityArchived.prototype.clearId = function() {
  this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.EntityArchived.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated DispatchedMessageId message_id = 2;
 * @return {!Array<!proto.spine.system.server.DispatchedMessageId>}
 */
proto.spine.system.server.EntityArchived.prototype.getMessageIdList = function() {
  return /** @type{!Array<!proto.spine.system.server.DispatchedMessageId>} */ (
    jspb.Message.getRepeatedWrapperField(this, spine_system_server_entity_history_pb.DispatchedMessageId, 2));
};


/** @param {!Array<!proto.spine.system.server.DispatchedMessageId>} value */
proto.spine.system.server.EntityArchived.prototype.setMessageIdList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.spine.system.server.DispatchedMessageId=} opt_value
 * @param {number=} opt_index
 * @return {!proto.spine.system.server.DispatchedMessageId}
 */
proto.spine.system.server.EntityArchived.prototype.addMessageId = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.spine.system.server.DispatchedMessageId, opt_index);
};


proto.spine.system.server.EntityArchived.prototype.clearMessageIdList = function() {
  this.setMessageIdList([]);
};


/**
 * optional google.protobuf.Timestamp when = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.spine.system.server.EntityArchived.prototype.getWhen = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/** @param {?proto.google.protobuf.Timestamp|undefined} value */
proto.spine.system.server.EntityArchived.prototype.setWhen = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.spine.system.server.EntityArchived.prototype.clearWhen = function() {
  this.setWhen(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.EntityArchived.prototype.hasWhen = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.system.server.EntityDeleted = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.spine.system.server.EntityDeleted.repeatedFields_, null);
};
goog.inherits(proto.spine.system.server.EntityDeleted, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.system.server.EntityDeleted.displayName = 'proto.spine.system.server.EntityDeleted';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.spine.system.server.EntityDeleted.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.system.server.EntityDeleted.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.system.server.EntityDeleted.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.system.server.EntityDeleted} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.EntityDeleted.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && spine_system_server_entity_history_pb.EntityHistoryId.toObject(includeInstance, f),
    messageIdList: jspb.Message.toObjectList(msg.getMessageIdList(),
    spine_system_server_entity_history_pb.DispatchedMessageId.toObject, includeInstance),
    when: (f = msg.getWhen()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.system.server.EntityDeleted}
 */
proto.spine.system.server.EntityDeleted.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.system.server.EntityDeleted;
  return proto.spine.system.server.EntityDeleted.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.system.server.EntityDeleted} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.system.server.EntityDeleted}
 */
proto.spine.system.server.EntityDeleted.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new spine_system_server_entity_history_pb.EntityHistoryId;
      reader.readMessage(value,spine_system_server_entity_history_pb.EntityHistoryId.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 2:
      var value = new spine_system_server_entity_history_pb.DispatchedMessageId;
      reader.readMessage(value,spine_system_server_entity_history_pb.DispatchedMessageId.deserializeBinaryFromReader);
      msg.addMessageId(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setWhen(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.system.server.EntityDeleted.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.system.server.EntityDeleted.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.system.server.EntityDeleted} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.EntityDeleted.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      spine_system_server_entity_history_pb.EntityHistoryId.serializeBinaryToWriter
    );
  }
  f = message.getMessageIdList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      spine_system_server_entity_history_pb.DispatchedMessageId.serializeBinaryToWriter
    );
  }
  f = message.getWhen();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional EntityHistoryId id = 1;
 * @return {?proto.spine.system.server.EntityHistoryId}
 */
proto.spine.system.server.EntityDeleted.prototype.getId = function() {
  return /** @type{?proto.spine.system.server.EntityHistoryId} */ (
    jspb.Message.getWrapperField(this, spine_system_server_entity_history_pb.EntityHistoryId, 1));
};


/** @param {?proto.spine.system.server.EntityHistoryId|undefined} value */
proto.spine.system.server.EntityDeleted.prototype.setId = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.system.server.EntityDeleted.prototype.clearId = function() {
  this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.EntityDeleted.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated DispatchedMessageId message_id = 2;
 * @return {!Array<!proto.spine.system.server.DispatchedMessageId>}
 */
proto.spine.system.server.EntityDeleted.prototype.getMessageIdList = function() {
  return /** @type{!Array<!proto.spine.system.server.DispatchedMessageId>} */ (
    jspb.Message.getRepeatedWrapperField(this, spine_system_server_entity_history_pb.DispatchedMessageId, 2));
};


/** @param {!Array<!proto.spine.system.server.DispatchedMessageId>} value */
proto.spine.system.server.EntityDeleted.prototype.setMessageIdList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.spine.system.server.DispatchedMessageId=} opt_value
 * @param {number=} opt_index
 * @return {!proto.spine.system.server.DispatchedMessageId}
 */
proto.spine.system.server.EntityDeleted.prototype.addMessageId = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.spine.system.server.DispatchedMessageId, opt_index);
};


proto.spine.system.server.EntityDeleted.prototype.clearMessageIdList = function() {
  this.setMessageIdList([]);
};


/**
 * optional google.protobuf.Timestamp when = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.spine.system.server.EntityDeleted.prototype.getWhen = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/** @param {?proto.google.protobuf.Timestamp|undefined} value */
proto.spine.system.server.EntityDeleted.prototype.setWhen = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.spine.system.server.EntityDeleted.prototype.clearWhen = function() {
  this.setWhen(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.EntityDeleted.prototype.hasWhen = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.system.server.EntityExtractedFromArchive = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.spine.system.server.EntityExtractedFromArchive.repeatedFields_, null);
};
goog.inherits(proto.spine.system.server.EntityExtractedFromArchive, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.system.server.EntityExtractedFromArchive.displayName = 'proto.spine.system.server.EntityExtractedFromArchive';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.spine.system.server.EntityExtractedFromArchive.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.system.server.EntityExtractedFromArchive.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.system.server.EntityExtractedFromArchive.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.system.server.EntityExtractedFromArchive} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.EntityExtractedFromArchive.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && spine_system_server_entity_history_pb.EntityHistoryId.toObject(includeInstance, f),
    messageIdList: jspb.Message.toObjectList(msg.getMessageIdList(),
    spine_system_server_entity_history_pb.DispatchedMessageId.toObject, includeInstance),
    when: (f = msg.getWhen()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.system.server.EntityExtractedFromArchive}
 */
proto.spine.system.server.EntityExtractedFromArchive.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.system.server.EntityExtractedFromArchive;
  return proto.spine.system.server.EntityExtractedFromArchive.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.system.server.EntityExtractedFromArchive} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.system.server.EntityExtractedFromArchive}
 */
proto.spine.system.server.EntityExtractedFromArchive.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new spine_system_server_entity_history_pb.EntityHistoryId;
      reader.readMessage(value,spine_system_server_entity_history_pb.EntityHistoryId.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 2:
      var value = new spine_system_server_entity_history_pb.DispatchedMessageId;
      reader.readMessage(value,spine_system_server_entity_history_pb.DispatchedMessageId.deserializeBinaryFromReader);
      msg.addMessageId(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setWhen(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.system.server.EntityExtractedFromArchive.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.system.server.EntityExtractedFromArchive.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.system.server.EntityExtractedFromArchive} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.EntityExtractedFromArchive.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      spine_system_server_entity_history_pb.EntityHistoryId.serializeBinaryToWriter
    );
  }
  f = message.getMessageIdList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      spine_system_server_entity_history_pb.DispatchedMessageId.serializeBinaryToWriter
    );
  }
  f = message.getWhen();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional EntityHistoryId id = 1;
 * @return {?proto.spine.system.server.EntityHistoryId}
 */
proto.spine.system.server.EntityExtractedFromArchive.prototype.getId = function() {
  return /** @type{?proto.spine.system.server.EntityHistoryId} */ (
    jspb.Message.getWrapperField(this, spine_system_server_entity_history_pb.EntityHistoryId, 1));
};


/** @param {?proto.spine.system.server.EntityHistoryId|undefined} value */
proto.spine.system.server.EntityExtractedFromArchive.prototype.setId = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.system.server.EntityExtractedFromArchive.prototype.clearId = function() {
  this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.EntityExtractedFromArchive.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated DispatchedMessageId message_id = 2;
 * @return {!Array<!proto.spine.system.server.DispatchedMessageId>}
 */
proto.spine.system.server.EntityExtractedFromArchive.prototype.getMessageIdList = function() {
  return /** @type{!Array<!proto.spine.system.server.DispatchedMessageId>} */ (
    jspb.Message.getRepeatedWrapperField(this, spine_system_server_entity_history_pb.DispatchedMessageId, 2));
};


/** @param {!Array<!proto.spine.system.server.DispatchedMessageId>} value */
proto.spine.system.server.EntityExtractedFromArchive.prototype.setMessageIdList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.spine.system.server.DispatchedMessageId=} opt_value
 * @param {number=} opt_index
 * @return {!proto.spine.system.server.DispatchedMessageId}
 */
proto.spine.system.server.EntityExtractedFromArchive.prototype.addMessageId = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.spine.system.server.DispatchedMessageId, opt_index);
};


proto.spine.system.server.EntityExtractedFromArchive.prototype.clearMessageIdList = function() {
  this.setMessageIdList([]);
};


/**
 * optional google.protobuf.Timestamp when = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.spine.system.server.EntityExtractedFromArchive.prototype.getWhen = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/** @param {?proto.google.protobuf.Timestamp|undefined} value */
proto.spine.system.server.EntityExtractedFromArchive.prototype.setWhen = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.spine.system.server.EntityExtractedFromArchive.prototype.clearWhen = function() {
  this.setWhen(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.EntityExtractedFromArchive.prototype.hasWhen = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.system.server.EntityRestored = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.spine.system.server.EntityRestored.repeatedFields_, null);
};
goog.inherits(proto.spine.system.server.EntityRestored, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.system.server.EntityRestored.displayName = 'proto.spine.system.server.EntityRestored';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.spine.system.server.EntityRestored.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.system.server.EntityRestored.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.system.server.EntityRestored.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.system.server.EntityRestored} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.EntityRestored.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && spine_system_server_entity_history_pb.EntityHistoryId.toObject(includeInstance, f),
    messageIdList: jspb.Message.toObjectList(msg.getMessageIdList(),
    spine_system_server_entity_history_pb.DispatchedMessageId.toObject, includeInstance),
    when: (f = msg.getWhen()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.system.server.EntityRestored}
 */
proto.spine.system.server.EntityRestored.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.system.server.EntityRestored;
  return proto.spine.system.server.EntityRestored.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.system.server.EntityRestored} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.system.server.EntityRestored}
 */
proto.spine.system.server.EntityRestored.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new spine_system_server_entity_history_pb.EntityHistoryId;
      reader.readMessage(value,spine_system_server_entity_history_pb.EntityHistoryId.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 2:
      var value = new spine_system_server_entity_history_pb.DispatchedMessageId;
      reader.readMessage(value,spine_system_server_entity_history_pb.DispatchedMessageId.deserializeBinaryFromReader);
      msg.addMessageId(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setWhen(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.system.server.EntityRestored.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.system.server.EntityRestored.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.system.server.EntityRestored} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.EntityRestored.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      spine_system_server_entity_history_pb.EntityHistoryId.serializeBinaryToWriter
    );
  }
  f = message.getMessageIdList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      spine_system_server_entity_history_pb.DispatchedMessageId.serializeBinaryToWriter
    );
  }
  f = message.getWhen();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional EntityHistoryId id = 1;
 * @return {?proto.spine.system.server.EntityHistoryId}
 */
proto.spine.system.server.EntityRestored.prototype.getId = function() {
  return /** @type{?proto.spine.system.server.EntityHistoryId} */ (
    jspb.Message.getWrapperField(this, spine_system_server_entity_history_pb.EntityHistoryId, 1));
};


/** @param {?proto.spine.system.server.EntityHistoryId|undefined} value */
proto.spine.system.server.EntityRestored.prototype.setId = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.system.server.EntityRestored.prototype.clearId = function() {
  this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.EntityRestored.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated DispatchedMessageId message_id = 2;
 * @return {!Array<!proto.spine.system.server.DispatchedMessageId>}
 */
proto.spine.system.server.EntityRestored.prototype.getMessageIdList = function() {
  return /** @type{!Array<!proto.spine.system.server.DispatchedMessageId>} */ (
    jspb.Message.getRepeatedWrapperField(this, spine_system_server_entity_history_pb.DispatchedMessageId, 2));
};


/** @param {!Array<!proto.spine.system.server.DispatchedMessageId>} value */
proto.spine.system.server.EntityRestored.prototype.setMessageIdList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.spine.system.server.DispatchedMessageId=} opt_value
 * @param {number=} opt_index
 * @return {!proto.spine.system.server.DispatchedMessageId}
 */
proto.spine.system.server.EntityRestored.prototype.addMessageId = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.spine.system.server.DispatchedMessageId, opt_index);
};


proto.spine.system.server.EntityRestored.prototype.clearMessageIdList = function() {
  this.setMessageIdList([]);
};


/**
 * optional google.protobuf.Timestamp when = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.spine.system.server.EntityRestored.prototype.getWhen = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/** @param {?proto.google.protobuf.Timestamp|undefined} value */
proto.spine.system.server.EntityRestored.prototype.setWhen = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.spine.system.server.EntityRestored.prototype.clearWhen = function() {
  this.setWhen(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.EntityRestored.prototype.hasWhen = function() {
  return jspb.Message.getField(this, 3) != null;
};


goog.object.extend(exports, proto.spine.system.server);

// The code for parsing the Protobuf messages of this file from the JSON data.

let known_type_parsers = require('../../../../known_type_parsers.js');

proto.spine.system.server.EntityCreated.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.system.server.EntityCreated.fromObject(jsObject);
};

proto.spine.system.server.EntityCreated.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.system.server.EntityCreated();
  
  if (obj.id !== undefined) {
    if (obj.id === null) {
      msg.setId(null);
    } else {
      let value = proto.spine.system.server.EntityHistoryId.fromObject(obj.id);
      msg.setId(value);
    }
  }
  
  if (obj.kind !== undefined) {
    if (obj.kind !== null) {
      let value = proto.EntityOption.Kind[obj.kind];
      msg.setKind(value);
    }
  }
  return msg;
};

proto.spine.system.server.EventDispatchedToSubscriber.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.system.server.EventDispatchedToSubscriber.fromObject(jsObject);
};

proto.spine.system.server.EventDispatchedToSubscriber.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.system.server.EventDispatchedToSubscriber();
  
  if (obj.receiver !== undefined) {
    if (obj.receiver === null) {
      msg.setReceiver(null);
    } else {
      let value = proto.spine.system.server.EntityHistoryId.fromObject(obj.receiver);
      msg.setReceiver(value);
    }
  }
  
  if (obj.payload !== undefined) {
    if (obj.payload === null) {
      msg.setPayload(null);
    } else {
      let value = proto.spine.core.Event.fromObject(obj.payload);
      msg.setPayload(value);
    }
  }
  
  if (obj.whenDispatched !== undefined) {
    if (obj.whenDispatched === null) {
      msg.setWhenDispatched(null);
    } else {
      let parser = known_type_parsers.parsers.get('type.googleapis.com/google.protobuf.Timestamp');
      let value = parser.parse(obj.whenDispatched);
      msg.setWhenDispatched(value);
    }
  }
  return msg;
};

proto.spine.system.server.EventDispatchedToReactor.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.system.server.EventDispatchedToReactor.fromObject(jsObject);
};

proto.spine.system.server.EventDispatchedToReactor.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.system.server.EventDispatchedToReactor();
  
  if (obj.receiver !== undefined) {
    if (obj.receiver === null) {
      msg.setReceiver(null);
    } else {
      let value = proto.spine.system.server.EntityHistoryId.fromObject(obj.receiver);
      msg.setReceiver(value);
    }
  }
  
  if (obj.payload !== undefined) {
    if (obj.payload === null) {
      msg.setPayload(null);
    } else {
      let value = proto.spine.core.Event.fromObject(obj.payload);
      msg.setPayload(value);
    }
  }
  
  if (obj.whenDispatched !== undefined) {
    if (obj.whenDispatched === null) {
      msg.setWhenDispatched(null);
    } else {
      let parser = known_type_parsers.parsers.get('type.googleapis.com/google.protobuf.Timestamp');
      let value = parser.parse(obj.whenDispatched);
      msg.setWhenDispatched(value);
    }
  }
  return msg;
};

proto.spine.system.server.CommandDispatchedToHandler.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.system.server.CommandDispatchedToHandler.fromObject(jsObject);
};

proto.spine.system.server.CommandDispatchedToHandler.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.system.server.CommandDispatchedToHandler();
  
  if (obj.receiver !== undefined) {
    if (obj.receiver === null) {
      msg.setReceiver(null);
    } else {
      let value = proto.spine.system.server.EntityHistoryId.fromObject(obj.receiver);
      msg.setReceiver(value);
    }
  }
  
  if (obj.payload !== undefined) {
    if (obj.payload === null) {
      msg.setPayload(null);
    } else {
      let value = proto.spine.core.Command.fromObject(obj.payload);
      msg.setPayload(value);
    }
  }
  
  if (obj.whenDispatched !== undefined) {
    if (obj.whenDispatched === null) {
      msg.setWhenDispatched(null);
    } else {
      let parser = known_type_parsers.parsers.get('type.googleapis.com/google.protobuf.Timestamp');
      let value = parser.parse(obj.whenDispatched);
      msg.setWhenDispatched(value);
    }
  }
  return msg;
};

proto.spine.system.server.EventImported.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.system.server.EventImported.fromObject(jsObject);
};

proto.spine.system.server.EventImported.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.system.server.EventImported();
  
  if (obj.receiver !== undefined) {
    if (obj.receiver === null) {
      msg.setReceiver(null);
    } else {
      let value = proto.spine.system.server.EntityHistoryId.fromObject(obj.receiver);
      msg.setReceiver(value);
    }
  }
  
  if (obj.eventId !== undefined) {
    if (obj.eventId === null) {
      msg.setEventId(null);
    } else {
      let value = proto.spine.core.EventId.fromObject(obj.eventId);
      msg.setEventId(value);
    }
  }
  
  if (obj.whenImported !== undefined) {
    if (obj.whenImported === null) {
      msg.setWhenImported(null);
    } else {
      let parser = known_type_parsers.parsers.get('type.googleapis.com/google.protobuf.Timestamp');
      let value = parser.parse(obj.whenImported);
      msg.setWhenImported(value);
    }
  }
  return msg;
};

proto.spine.system.server.EntityStateChanged.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.system.server.EntityStateChanged.fromObject(jsObject);
};

proto.spine.system.server.EntityStateChanged.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.system.server.EntityStateChanged();
  
  if (obj.id !== undefined) {
    if (obj.id === null) {
      msg.setId(null);
    } else {
      let value = proto.spine.system.server.EntityHistoryId.fromObject(obj.id);
      msg.setId(value);
    }
  }
  
  if (obj.newState !== undefined) {
    if (obj.newState === null) {
      msg.setNewState(null);
    } else {
      let parser = known_type_parsers.parsers.get('type.googleapis.com/google.protobuf.Any');
      let value = parser.parse(obj.newState);
      msg.setNewState(value);
    }
  }
  
  if (obj.messageId !== undefined && obj.messageId !== null) {
    obj.messageId.forEach(
      (listItem, index, array) => {
        if (listItem === null) {
          msg.addMessageId(null);
        } else {
          let value = proto.spine.system.server.DispatchedMessageId.fromObject(listItem);
          msg.addMessageId(value);
        }
      }
    );
  }
  
  if (obj.when !== undefined) {
    if (obj.when === null) {
      msg.setWhen(null);
    } else {
      let parser = known_type_parsers.parsers.get('type.googleapis.com/google.protobuf.Timestamp');
      let value = parser.parse(obj.when);
      msg.setWhen(value);
    }
  }
  return msg;
};

proto.spine.system.server.EntityArchived.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.system.server.EntityArchived.fromObject(jsObject);
};

proto.spine.system.server.EntityArchived.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.system.server.EntityArchived();
  
  if (obj.id !== undefined) {
    if (obj.id === null) {
      msg.setId(null);
    } else {
      let value = proto.spine.system.server.EntityHistoryId.fromObject(obj.id);
      msg.setId(value);
    }
  }
  
  if (obj.messageId !== undefined && obj.messageId !== null) {
    obj.messageId.forEach(
      (listItem, index, array) => {
        if (listItem === null) {
          msg.addMessageId(null);
        } else {
          let value = proto.spine.system.server.DispatchedMessageId.fromObject(listItem);
          msg.addMessageId(value);
        }
      }
    );
  }
  
  if (obj.when !== undefined) {
    if (obj.when === null) {
      msg.setWhen(null);
    } else {
      let parser = known_type_parsers.parsers.get('type.googleapis.com/google.protobuf.Timestamp');
      let value = parser.parse(obj.when);
      msg.setWhen(value);
    }
  }
  return msg;
};

proto.spine.system.server.EntityDeleted.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.system.server.EntityDeleted.fromObject(jsObject);
};

proto.spine.system.server.EntityDeleted.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.system.server.EntityDeleted();
  
  if (obj.id !== undefined) {
    if (obj.id === null) {
      msg.setId(null);
    } else {
      let value = proto.spine.system.server.EntityHistoryId.fromObject(obj.id);
      msg.setId(value);
    }
  }
  
  if (obj.messageId !== undefined && obj.messageId !== null) {
    obj.messageId.forEach(
      (listItem, index, array) => {
        if (listItem === null) {
          msg.addMessageId(null);
        } else {
          let value = proto.spine.system.server.DispatchedMessageId.fromObject(listItem);
          msg.addMessageId(value);
        }
      }
    );
  }
  
  if (obj.when !== undefined) {
    if (obj.when === null) {
      msg.setWhen(null);
    } else {
      let parser = known_type_parsers.parsers.get('type.googleapis.com/google.protobuf.Timestamp');
      let value = parser.parse(obj.when);
      msg.setWhen(value);
    }
  }
  return msg;
};

proto.spine.system.server.EntityExtractedFromArchive.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.system.server.EntityExtractedFromArchive.fromObject(jsObject);
};

proto.spine.system.server.EntityExtractedFromArchive.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.system.server.EntityExtractedFromArchive();
  
  if (obj.id !== undefined) {
    if (obj.id === null) {
      msg.setId(null);
    } else {
      let value = proto.spine.system.server.EntityHistoryId.fromObject(obj.id);
      msg.setId(value);
    }
  }
  
  if (obj.messageId !== undefined && obj.messageId !== null) {
    obj.messageId.forEach(
      (listItem, index, array) => {
        if (listItem === null) {
          msg.addMessageId(null);
        } else {
          let value = proto.spine.system.server.DispatchedMessageId.fromObject(listItem);
          msg.addMessageId(value);
        }
      }
    );
  }
  
  if (obj.when !== undefined) {
    if (obj.when === null) {
      msg.setWhen(null);
    } else {
      let parser = known_type_parsers.parsers.get('type.googleapis.com/google.protobuf.Timestamp');
      let value = parser.parse(obj.when);
      msg.setWhen(value);
    }
  }
  return msg;
};

proto.spine.system.server.EntityRestored.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.system.server.EntityRestored.fromObject(jsObject);
};

proto.spine.system.server.EntityRestored.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.system.server.EntityRestored();
  
  if (obj.id !== undefined) {
    if (obj.id === null) {
      msg.setId(null);
    } else {
      let value = proto.spine.system.server.EntityHistoryId.fromObject(obj.id);
      msg.setId(value);
    }
  }
  
  if (obj.messageId !== undefined && obj.messageId !== null) {
    obj.messageId.forEach(
      (listItem, index, array) => {
        if (listItem === null) {
          msg.addMessageId(null);
        } else {
          let value = proto.spine.system.server.DispatchedMessageId.fromObject(listItem);
          msg.addMessageId(value);
        }
      }
    );
  }
  
  if (obj.when !== undefined) {
    if (obj.when === null) {
      msg.setWhen(null);
    } else {
      let parser = known_type_parsers.parsers.get('type.googleapis.com/google.protobuf.Timestamp');
      let value = parser.parse(obj.when);
      msg.setWhen(value);
    }
  }
  return msg;
};
